(function () {
  const NAV_SEL = ".mm-nav";
  const TOP_BTN_SEL = ".mm-top__link--toggle";  // opens/closes main mega panel
  const SUB_BTN_SEL = ".mm-link--toggle";       // opens flyout sub panel

  const PANEL_SEL = ".mm-panel";
  const MENUS_SEL = ".mm-panel__menus";
  const SUB_SEL = ".mm-sub";

  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.from(root.querySelectorAll(sel)); }

  function closeAllTop(nav) {
    qsa(nav, `${TOP_BTN_SEL}[aria-expanded="true"]`).forEach((btn) => {
      btn.setAttribute("aria-expanded", "false");
      const id = btn.getAttribute("aria-controls");
      const panel = id && document.getElementById(id);
      if (panel) panel.hidden = true;
    });
  }

  // Initialize flyout behavior for ONE mega panel
  function initFlyout(panelEl) {
    if (!panelEl || panelEl.dataset.mmFlyoutInit === "1") return;

    const menus = qs(panelEl, MENUS_SEL);
    if (!menus) return;

    panelEl.dataset.mmFlyoutInit = "1";

    // Create flyout stack containers
    const flyout = document.createElement("div");
    flyout.className = "mm-flyout";

    const viewport = document.createElement("div");
    viewport.className = "mm-flyout__viewport";

    const track = document.createElement("div");
    track.className = "mm-flyout__track";

    // Root panel: contains the original UL produced by mm-recursive at depth=1
    const rootPanel = document.createElement("div");
    rootPanel.className = "mm-flyout__panel";
    rootPanel.dataset.panelId = "root";

    // Move existing content into root panel
    while (menus.firstChild) rootPanel.appendChild(menus.firstChild);

    track.appendChild(rootPanel);
    viewport.appendChild(track);
    flyout.appendChild(viewport);

    menus.appendChild(flyout);

    // State
    panelEl._mm = {
      viewport,
      track,
      activeIndex: 0,
      panelOrder: ["root"] // list of panelIds in order in the track
    };

    // Helper: translate to activeIndex
    function applyTranslate() {
      const mm = panelEl._mm;
      if (!mm) return;
      const w = mm.viewport.getBoundingClientRect().width;
      mm.track.style.transform = `translateX(${-w * mm.activeIndex}px)`;
    }

    function resetFlyout() {
      const mm = panelEl._mm;
      if (!mm) return;

      // reset position
      mm.activeIndex = 0;
      applyTranslate();

      // collapse all submenu buttons
      qsa(panelEl, `${SUB_BTN_SEL}[aria-expanded="true"]`).forEach((b) => {
        b.setAttribute("aria-expanded", "false");
      });
    }

    // Build / reuse a panel for a submenu div.mm-sub
    function ensurePanel(subDiv, titleText) {
      const mm = panelEl._mm;
      const panelId = subDiv.id;

      // already created?
      if (mm.panelOrder.includes(panelId)) return;

      const newPanel = document.createElement("div");
      newPanel.className = "mm-flyout__panel";
      newPanel.dataset.panelId = panelId;

      // Header (Back + title) — shows on mobile via CSS
      const header = document.createElement("div");
      header.className = "mm-flyout__header";

      const back = document.createElement("button");
      back.className = "mm-flyout__back";
      back.type = "button";
      back.textContent = "Back";
      back.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        flyoutBack();
      });

      const title = document.createElement("div");
      title.className = "mm-flyout__title";
      title.textContent = titleText || "";

      header.appendChild(back);
      header.appendChild(title);

      const content = document.createElement("div");
      content.className = "mm-flyout__content";

      // Move the UL from the hidden mm-sub into this panel
      const ul = subDiv.querySelector("ul");
      if (ul) content.appendChild(ul);

      newPanel.appendChild(header);
      newPanel.appendChild(content);

      // Append panel to track
      track.appendChild(newPanel);
      mm.panelOrder.push(panelId);

      // Keep original submenu container hidden forever (now “consumed”)
      subDiv.hidden = true;
    }

    // Open a given panelId
    function goToPanel(panelId) {
      const mm = panelEl._mm;
      const idx = mm.panelOrder.indexOf(panelId);
      if (idx < 0) return;

      mm.activeIndex = idx;
      applyTranslate();
    }

    // Back one panel
    function flyoutBack() {
      const mm = panelEl._mm;
      if (!mm) return;

      mm.activeIndex = Math.max(0, mm.activeIndex - 1);
      applyTranslate();

      // Clear expanded states when backing up to keep path clean
      qsa(panelEl, SUB_BTN_SEL).forEach((b) => b.setAttribute("aria-expanded", "false"));
    }

    // Click handling inside this mega panel (submenus)
    panelEl.addEventListener("click", (e) => {
      const btn = e.target.closest(SUB_BTN_SEL);
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      const subId = btn.getAttribute("aria-controls");
      const subDiv = subId && document.getElementById(subId);
      if (!subDiv) return;

      // One-path behavior: collapse all other toggles
      qsa(panelEl, SUB_BTN_SEL).forEach((b) => {
        if (b !== btn) b.setAttribute("aria-expanded", "false");
      });

      // Expand this one
      btn.setAttribute("aria-expanded", "true");

      // Create panel if needed, then go to it
      const titleText = btn.querySelector(".mm-link__label")?.textContent?.trim() || btn.textContent.trim();
      ensurePanel(subDiv, titleText);
      goToPanel(subDiv.id);
    });

    // Reset whenever this mega panel is opened
    panelEl.addEventListener("mm:open", resetFlyout);

    // Resize safety
    window.addEventListener("resize", applyTranslate);

    // First-time position
    resetFlyout();
  }

  // --- Document-level behavior: open/close top panels ---
  document.addEventListener("click", (e) => {
    const nav = e.target.closest(NAV_SEL);

    // click outside nav closes
    if (!nav) {
      const anyNav = document.querySelector(NAV_SEL);
      if (anyNav) closeAllTop(anyNav);
      return;
    }

    const topBtn = e.target.closest(TOP_BTN_SEL);
    if (topBtn) {
      e.preventDefault();
      e.stopPropagation();

      const id = topBtn.getAttribute("aria-controls");
      const panel = id && document.getElementById(id);
      if (!panel) return;

      const expanded = topBtn.getAttribute("aria-expanded") === "true";

      // close other top panels first
      closeAllTop(nav);

      // toggle this one
      topBtn.setAttribute("aria-expanded", expanded ? "false" : "true");
      panel.hidden = expanded ? true : false;

      if (!expanded) {
        initFlyout(panel);
        // notify flyout to reset
        panel.dispatchEvent(new CustomEvent("mm:open"));
      }

      return;
    }

    // Clicking inside an open panel should not close it
    if (e.target.closest(PANEL_SEL)) return;

    // otherwise close
    closeAllTop(nav);
  });

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    const nav = document.querySelector(NAV_SEL);
    if (nav) closeAllTop(nav);
  });
})();
